import '@/store/init_kysely_module';
import './browser_offline_init';

import '../../modules';
